import React from 'react';
import { Table as TableStrap } from 'reactstrap';
const Table = props => {
    return (
        <TableStrap hover responsive className="table-outline d-sm-table" {...props}>
            {props.children}
        </TableStrap>
    )
};
export default Table